import toast from "react-hot-toast";
import {
  addInterestEndpoint,
  getInterestedUsersEndpoint,
  getTopRequestedRoutesEndpoint,
} from "../apiEndpoints";
import { apiConnector } from "../apiConnection";

//TODO
const login = localStorage.getItem("token");
// export const addInterestApi = async (from, to) => {
//   try {
//     const bodyData = {
//       from,
//       to,
//     };
//     const request = {
//       url: addInterestEndpoint.url,
//       method: addInterestEndpoint.method,
//       bodyData,
//       headers: {
//         Authorization: `Bearer ${login}`,
//       },
//     };
//     toast.loading("Adding your interest...");
//     const res = await apiConnector(request);
//     const data = res?.data;
//     if (!data || !data.success)
//       throw new Error(data?.message || "error occurred");
//     toast.dismiss();
//     toast.success("Interest added successfully!");
//     return data;
//   } catch (error) {
//     toast.dismiss();
//     toast.error("Could not add interest");
//     toast.error(error?.message || "An error occurred");
//     console.error(error);
//   }
// };

export const addInterestApi = async (from, to, date) => {
  try {
    const bodyData = {
      from,
      to,
    };
    if (date) bodyData.date = date;

    const request = {
      url: addInterestEndpoint.url,
      method: addInterestEndpoint.method,
      bodyData,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };

    toast.loading("Adding your interest...");
    await apiConnector(request);
    toast.dismiss();
    toast.success("Interest added successfully!");
  } catch (error) {
    toast.dismiss();
    toast.error("Could not add interest");
    toast.error(error?.message || "An error occurred");
    console.error(error);
  }
};

export const getTopRequestedRoutesApi = async () => {
  try {
    const request = {
      url: getTopRequestedRoutesEndpoint.url,
      method: getTopRequestedRoutesEndpoint.method,
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    const response = await apiConnector(request);
    const data = response?.data;
    if (!data) throw new Error(data?.message || "error occurred");
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getInterestedUsersApi = async (from, to) => {
  try {
    const request = {
      url: getInterestedUsersEndpoint.url,
      method: getInterestedUsersEndpoint.method,
      params: {
        from,
        to,
      },
      headers: {
        Authorization: `Bearer ${login}`,
      },
    };
    const response = await apiConnector(request);
    const data = response?.data;
    if (!data) throw new Error(data?.message || "error occurred");
    return data.interest_count;
  } catch (error) {
    console.error(error);
  }
};
